import React, { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { returnToPreviousMacroWizardPath } from '../../../../actions/searchActions';
import {
  getCurrentDecisionNodeContent,
  getSimplrAccountIdOfSelectedTicket,
  extractSelectedTicketFromState,
} from '../../../../extractFromState';
import {
  SearchResultsContainer,
  HeaderContainer,
  Title,
  SubTitle,
  ResultsSection,
  SearchOrdersBox,
  SearchInputContainer,
  SpaceHolder,
  Container,
  SearchOrderContent,
  SearchAndResults,
  NoResultsWrapper,
} from './DTCustomerAccountView.styles';

import { getCustomers, getSelectedOrderSearchAction } from '../../../../selectors/tools';
import { LoadingStateWrapper } from '../../../common/LoadingStateWrapper/LoadingStateWrapper';
import { LoadingStateContextConsumer } from '../../../common/LoadingStateWrapper/LoadingStateContext';
import { setLoading as setLoadingAction } from '../../../../actions';
import NoSearchResults from './Common/NoSearchResults/NoSearchResults';
import { SearchResults } from './Common/SearchResults/SearchResults';
import DTSearchInput from '../../Common/DTSearchInput/DTSearchInput';
import { Loader } from '../../../common/Loader/Loader';
import { lookupAndSetCustomers } from 'actions/tools/GladlyActions';
import { displayPopupMessageInformation } from 'components/tools/SearchPage/searchUtils';
import { validate as validateEmail } from 'email-validator';
import { BackButton, NextButton } from 'components/common/buttonsComponents';
import { ActionsButtonsWrapper } from '../../DecisionTree.styles';

export const DTCustomerAccountView = (props) => {
  const { onNextButtonClick, isNextButtonActive } = props;
  const dispatch = useDispatch();
  const content = useSelector(getCurrentDecisionNodeContent);
  const { customerEmail } = useSelector(extractSelectedTicketFromState);
  const customers = useSelector(getCustomers);
  const simplrAccountId = useSelector(getSimplrAccountIdOfSelectedTicket);
  const selectedSearchAction = useSelector(getSelectedOrderSearchAction);
  const isLoading = useSelector(
    (state) => state.ui.loading.isLoading && state.ui.loading.component === 'DTCustomerAccountView'
  );
  const setLoading = useCallback((loading) => dispatch(setLoadingAction(loading, 'DTCustomerAccountView')), [dispatch]);

  const handleSearchSubmit = useCallback(
    async (value) => {
      if (!validateEmail(value)) {
        return displayPopupMessageInformation('Please enter a valid email address');
      }
      setLoading(true);
      await dispatch(lookupAndSetCustomers(value, simplrAccountId));
      setLoading(false);
    },
    [dispatch, setLoading, simplrAccountId]
  );

  useEffect(() => {
    validateEmail(customerEmail) && handleSearchSubmit(customerEmail);
  }, [customerEmail, handleSearchSubmit]);

  const handleBackButtonClick = () => dispatch(returnToPreviousMacroWizardPath());

  return (
    <Container>
      <HeaderContainer id="HeaderContainer">
        {content?.title && <Title>{content.title}</Title>}
        {content?.subText && <SubTitle>{content.subText}</SubTitle>}
        <SearchOrdersBox>
          <SearchInputContainer>
            <DTSearchInput
              placeholder="Search by email"
              messageImg={false}
              searchType={selectedSearchAction}
              searchValue={customerEmail}
              defaultValue={customerEmail}
              onSearchSubmit={handleSearchSubmit}
            />
          </SearchInputContainer>
          <SpaceHolder />
        </SearchOrdersBox>
      </HeaderContainer>
      <SearchResultsContainer>
        <LoadingStateWrapper
          data={customers}
          isPending={isLoading}
          noDataMessage={
            <NoResultsWrapper key={'noOrdersFound'}>
              <Title>No customers found</Title>
              <NoSearchResults />
            </NoResultsWrapper>
          }
        >
          <LoadingStateContextConsumer>
            {() => (
              <Loader visible={isLoading}>
                <SearchOrderContent id="SearchOrderContent">
                  <SearchAndResults id="SearchAndResults">
                    <ResultsSection id="ResultsSection">
                      <SearchResults />
                    </ResultsSection>
                  </SearchAndResults>
                </SearchOrderContent>
              </Loader>
            )}
          </LoadingStateContextConsumer>
        </LoadingStateWrapper>
      </SearchResultsContainer>

      <ActionsButtonsWrapper key={'navigation'}>
        <NextButton
          active={isNextButtonActive}
          disabled={!isNextButtonActive}
          type="submit"
          onClick={onNextButtonClick}
        >
          NEXT
        </NextButton>
        <BackButton onClick={handleBackButtonClick}>BACK</BackButton>
      </ActionsButtonsWrapper>
    </Container>
  );
};

export default DTCustomerAccountView;
